/* tslint:disable */
/* eslint-disable */
export enum ApplicationMessageType {
  None = 'None',
  DealerChat = 'DealerChat'
}
